import { createStore } from 'satcheljs';
var initialMarkReadStore = {
    markAsReadTimerTask: null,
    suppressedItemIdsMap: {},
};
var markReadStore = createStore('markread', initialMarkReadStore)();
export default markReadStore;
//# sourceMappingURL=Store.js.map